import {forEach} from "../../js/helpers";

export function item(itemEl) {
  const footerEl = itemEl.querySelector('.item__footer');
  if (footerEl) {
    itemEl.style.setProperty('--max-height', itemEl.scrollHeight + 'px');
  }
  itemEl.addEventListener('mouseenter', () => {
    itemEl.classList.add('is-hover')
  });
  itemEl.addEventListener('mouseleave', () => {
    setTimeout(() => {
      itemEl.classList.remove('is-hover')
    }, 300)
  });
}

